import { TFunction } from "react-i18next";
import { II18nextTypes } from "common/src/types/i18n";
import { CreateBookingFirebaseNew } from "./CreateFirebase";
import { ValidateBookingObjectNew } from "./ValidateObject";
import { isNullOrUndefined } from "../utils/isNullOrUndefined";
import { PrepareEstimateObjectNew } from "./PrepareEstimateObject";
import { IBookingType, IEstimateType, ISettingsType, ITripDataType, IUserType } from "common/src/types";


interface AddBookingNewProps {
    t: TFunction;
    drivers: IUserType[];
    isTaximeter: boolean;
    tripdata: ITripDataType;
    settings: ISettingsType;
    estimate?: IEstimateType;
    passenger: Partial<IUserType>;
    payment_mode?: IBookingType['payment_mode'];
}

interface CreateBookingFirebaseNewResponse {
    error?: boolean;
    msg?: keyof II18nextTypes;
    bookingData?: IBookingType;
}

export const AddBookingNew = async ({ tripdata, settings, passenger, drivers, t, estimate, payment_mode, isTaximeter }: AddBookingNewProps): Promise<CreateBookingFirebaseNewResponse> => {
    try {

        let validatedPassenger = { ...passenger };

        if (!validatedPassenger.firstName) {
            validatedPassenger.firstName = t("NOT_INFORMED");
        }

        if (!validatedPassenger.lastName) {
            validatedPassenger.lastName = "";
        }

        if (!validatedPassenger.email) {
            validatedPassenger.email = t("NOT_INFORMED");
        }

        if (!validatedPassenger.mobile) {
            validatedPassenger.mobile = t("NOT_INFORMED");
        }

        if (!validatedPassenger.verifyId) {
            validatedPassenger.verifyId = t("NOT_INFORMED");
        }

        if (!validatedPassenger.rating) {
            validatedPassenger.rating = "0"
        }

        if (isNullOrUndefined(drivers) || isNullOrUndefined(drivers[0].id)) {
            return { error: true, msg: "no_driver_found_alert_messege" }
        }

        if (isNullOrUndefined(tripdata.pickup)) {
            return { error: true, msg: "select_pickup_location" }
        }

        if (isNullOrUndefined(tripdata.drop)) {
            return { error: true, msg: "drop_location_blank_error" }
        }

        if (isNullOrUndefined(tripdata.carType?.name)) {
            return { error: true, msg: 'car_type_blank_error' }
        }

        if (isNullOrUndefined(payment_mode)) {
            return { error: true, msg: "SELECT_PAYMENT_MODE" }
        }

        let estimateData;

        if (estimate) {
            estimateData = estimate
        }
        else {
            let resultEstimate = await PrepareEstimateObjectNew({ tripdata, settings: settings! });

            if (resultEstimate.error) {
                return {
                    error: true,
                    msg: resultEstimate.msg
                }
            }

            estimateData = resultEstimate.estimateObject
        }

        const resultValidate = await ValidateBookingObjectNew({
            tripdata,
            settings,
            drivers,
            passenger: validatedPassenger, // 👈 Usa o passenger com fallback
            isTaximeter,
            payment_mode,
            estimate: estimateData!,
        });

        if (resultValidate.error) {
            return {
                error: true,
                msg: resultValidate.msg
            }

        } else {

            let resultCreateBookingFirebase = await CreateBookingFirebaseNew({
                addBookingObj: resultValidate.addBookingObj!,
                t
            });

            if (resultCreateBookingFirebase.error) {
                return {
                    error: true,
                    msg: resultCreateBookingFirebase.msg
                }
            }

            return {
                bookingData: resultCreateBookingFirebase.bookingData!
            }
        }

    }
    catch (e) {
        console.error(e)
        return {
            error: true,
            msg: e as any
        }
    }
};